__turbopack_context__.v({
  "feedbackBtnDesktop": "NdD79G_feedbackBtnDesktop",
});
